var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityMobilityImpairedWalker = function SvgAccessibilityMobilityImpairedWalker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m20.512 21.055 7.008 1.515a.758.758 0 0 0 .948-.758V4.954a.758.758 0 0 0-.948-.758l-7.046 1.516a.76.76 0 0 0-.606.757v13.828a.76.76 0 0 0 .644.758m-.341 0-3.637.265v1.288l-3.637.265v1.402l7.426 1.553v-1.402l3.636-.265v-1.288l3.637-.265m-24.662-9.32.113 11.214a.49.49 0 0 0 .53.493h.342a.52.52 0 0 0 .53-.53l.417-5.646h.644l.417 5.645a.52.52 0 0 0 .53.53h.34a.51.51 0 0 0 .531-.492l.076-11.29"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m7.366 13.25 1.44 1.554a.8.8 0 0 1 .151.416l.076 1.63a.72.72 0 1 0 1.44 0l-.114-1.857a1.55 1.55 0 0 0-.265-.833S8.2 11.62 7.972 11.508a2.15 2.15 0 0 0-1.06-.379H2.82s-1.288-.076-1.288 1.402v4.394c0 1.63 1.288 1.478 1.288 1.478m8.865 6.629-1.894-7.387m14.169 6.516-7.426-1.553-3.637.265 7.426 1.553m-3.789-3.106 7.425 1.553"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 5.169,
    cy: 8.401,
    r: 1.515
  }))));
};
export default SvgAccessibilityMobilityImpairedWalker;